import checkNumber from 'lodash-es/isNumber';

const isObject = (a) => a != null && a.constructor === Object;
const isArray = (a) => Array.isArray(a);
const isNumber = (a) => checkNumber(a);
const isString = (a) => typeof a === 'string';
const isBool = (a) => typeof a === 'boolean';
const isInteger = (n) => Number(n) === n && n % 1 === 0;
const isFloat = (n) => Number(n) === n && n % 1 !== 0;
const isDate = (date) => {
  if (date === null) return false;
  return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date));
};

export { isArray, isBool, isFloat, isInteger, isNumber, isObject, isString, isDate };
